/** 空运报价单价标记，复用既有费用行字段，避免与历史重量段混淆。 */
export const AIR_UNIT_PRICE = 'UNIT_PRICE'

const toNumber = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === '') return undefined
  const result = Number(value)
  return Number.isFinite(result) && result >= 0 ? result : undefined
}

/** 与询价详情一致：以货物合计毛重和体积重中的较大值作为计费重（KG）。 */
export const getAirChargeableWeight = (detail: Record<string, any>): number | undefined => {
  const cargoList = Array.isArray(detail.cargoList) ? detail.cargoList : []
  const sumMetric = (key: string) => {
    const values = cargoList.map(cargo => toNumber(cargo?.[key])).filter(value => value !== undefined) as number[]
    return values.length ? cargoList.reduce((sum, cargo) => sum + (toNumber(cargo?.[key]) ?? 0) * (toNumber(cargo?.quantity) ?? 0), 0) : undefined
  }
  const weight = toNumber(detail.weight) ?? sumMetric('weight')
  const cubage = toNumber(detail.cubage) ?? sumMetric('cubage')
  if (weight === undefined && cubage === undefined) return undefined
  return Math.max(weight ?? 0, (cubage ?? 0) * 1000000 / 6000)
}

/** 历史报价只取计费重所在档位；M 是最低收费，不能作为计重单价。 */
export const getAirWeightBreakStart = (value: unknown): number | undefined => {
  const label = String(value || '').trim().toUpperCase().replace(/\s+/g, '')
  if (/^M(?:\(|（|$)/.test(label)) return undefined
  if (/^N(?:\(|（|$)/.test(label)) return 0
  const match = label.match(/\d+(?:\.\d+)?/)
  return match ? Number(match[0]) : undefined
}

/** 优先显示新单价；历史报价按实际计费重选择对应档位，未报价时保持空值。 */
export const selectAirUnitRate = <T extends Record<string, any>>(items: T[], weight: number | undefined): T | undefined => {
  const unitRate = items.find(item => item.chargeMode === AIR_UNIT_PRICE || item.weightBreak === AIR_UNIT_PRICE)
  if (unitRate) return unitRate
  if (weight === undefined) return undefined
  return items
    .map(item => ({ item, start: getAirWeightBreakStart(item.weightBreak) }))
    .filter((entry): entry is { item: T; start: number } => entry.start !== undefined && entry.start <= weight)
    .sort((left, right) => right.start - left.start)[0]?.item
}
